import "../style/login/Login.css";
import Login from "../components/sign/Login";
import Header from "../components/beforeLogin/Header";
import Footer from "../components/beforeLogin/Footer";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect } from "react";
import { useCookies } from "react-cookie";
// import PageTransition from "../utils/PageTransition";

const Home = () => {
  const navigate = useNavigate();

  const [token] = useCookies(["jwt"]);
  const jwt = token?.jwt;

  const handleLogin = useCallback(() => {
    navigate("/login");
  }, [navigate]);

  const handleSign = useCallback(() => {
    navigate("/register");
  }, [navigate]);

  useEffect(() => {
    if (jwt !== undefined && jwt !== null && jwt.length !== 0) {
      navigate("/dashboard");
    }
  }, [jwt, navigate]);

  return (
    <>
      {/* <PageTransition> */}
      <Header />
      <section className="login">
        <div className="login-sign">
          <div className="login-sign-container">
            <div className="sign-choice">
              <div className="sign-choice-wrapper">
                <button onClick={handleLogin} className="navLink active">
                  Giriş Yap
                </button>
                <button onClick={handleSign} className="navLink">
                  Kayıt Ol
                </button>
              </div>
            </div>
          </div>
          <Login />
        </div>
      </section>
      {/* </PageTransition> */}
    </>
  );
};

export default Home;
